import { AxiosResponse } from 'axios';
import utils from 'utils';
import { CANCELLED_SUBSCRIPTION_STATUSES } from '../../constant';

class TrialPeriodEntity {
  static DAY_LEFT_TO_SHOW_BANNER = [4, 2];

  static isTrialEnded(daysLeft: number) {
    return daysLeft < 0;
  }

  static toShowTrialEnding(daysLeft: number) {
    const { showTrialDialogOnLogin } = utils.getLocalStorageByKey(
      'showTrialDialogOnLogin'
    );
    return (
      showTrialDialogOnLogin &&
      TrialPeriodEntity.DAY_LEFT_TO_SHOW_BANNER.includes(daysLeft)
    );
  }

  static toShowFooterBanner(daysLeft: number) {
    return !TrialPeriodEntity.isTrialEnded(daysLeft);
  }
}

export function mapTrialPeriodResponse(response: AxiosResponse) {
  const {
    inTrial,
    trialDuration,
    trialEndDate,
    suspended,
    dayOfTrial,
    userPaymentStatus,
  } = response.data;
  const now = new Date();

  const delta = Math.max(utils.getDaysDifference(trialEndDate, now.toString()), -1);
  const subscriptionCancelled =
    CANCELLED_SUBSCRIPTION_STATUSES.includes(userPaymentStatus);

  return {
    isTrialEnded: TrialPeriodEntity.isTrialEnded(delta),
    showSelectTrialPopUp:
      TrialPeriodEntity.toShowTrialEnding(delta) || suspended,
    showFooterBanner: TrialPeriodEntity.toShowFooterBanner(delta),
    daysLeft: delta,

    trialEndDate,
    inTrial,
    suspended,
    dayOfTrial,
    trialDuration,
    subscriptionCancelled,
  };
}

export default { mapTrialPeriodResponse };
